export default __webpack_public_path__ + "static/media/tiger_HAPPY.39269b93.png";